import { RadioGroup } from '@zoopla-eng/zds-components/radio-group';

const propertyTypes = ['property', 'houses', 'flats', 'farms_land'] as const;

export type PropertyType = typeof propertyTypes[number];

type SelectPropertyTypeProps = {
    value: PropertyType;
    onChange: (propertyType: PropertyType) => void;
};

export const SelectPropertyType = ({
    value,
    onChange
}: SelectPropertyTypeProps) => {
    return (
        <RadioGroup
            label=""
            bisect={true}
            value={value}
            items={[
                {
                    id: 'show_all',
                    value: 'property',
                    label: 'Show all'
                },
                {
                    id: 'houses',
                    value: 'houses',
                    label: 'Houses'
                },
                {
                    id: 'flats',
                    value: 'flats',
                    label: 'Flats'
                }
            ]}
            onValueChange={onChange}
        />
    );
};
